// src/pages/Faq.js
import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import translations from '../translations';
import { useMeta } from '../useMeta';

function Faq({ language = 'en' }) {
  const t = translations[language] || translations['en'];
  const prefix = language === 'en' ? '' : `/${language}`;

  useMeta({
    title: `${t.faq.title} | ERC Unlock`,
    description: language === 'en'
      ? 'Answers to common questions about Toyota ERC unlock codes, why head units lock, supported models, refunds, and how the unlock process works.'
      : undefined,
    canonical: `https://ercunlock.com${prefix}/faq`
  });

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ur' ? 'rtl' : 'ltr';
    document.title = `${t.faq.title} | ERC Unlock`;
  }, [language, t.faq.title]);

  // FAQPage structured data for rich snippets
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": t.faq.items.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Layout language={language}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="content-card">
        <h1>{t.faq.title}</h1>
        <div className="prose">
          {t.faq.items.map((item, i) => (
            <div key={i}>
              <h2>{item.question}</h2>
              <p>{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Faq;
